const initialState = {
  fetching: false,
};

export default function userReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'USER_FETCHING':
      return { ...currentState, fetching: true };
    case 'USERS_FETCHING':
      return { ...currentState, fetching: true };
    case 'USER_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    case 'USERS_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
